import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { BranchService } from 'src/app/shared/API-Service/services/branch.service';
import { JoinTypeService } from 'src/app/shared/API-Service/services/join-type.service';
import { JoinRequestService } from 'src/app/shared/API-Service/services/join-request.service';
import { CityService } from 'src/app/shared/API-Service/services/city.service';
@Component({
  selector: 'app-insert-join-request',
  templateUrl: './insert-join-request.component.html',
  styleUrls: ['./insert-join-request.component.css']
})
export class InsertJoinRequestComponent implements OnInit {
recordtoupdate: any;
cities:any;
jointype:any;
joinrequestForm:FormGroup;
update:boolean = false;
button:boolean = false;
  city: any;
  joinType: any;
  comments: any;
  mobile: any;
  address: any;
  name: any;
  constructor(private _JoinRequestService:JoinRequestService,private _Router:Router,
     private _CityService:CityService,private _JoinTypeService:JoinTypeService,private _FormBuilder:FormBuilder) { }

  ngOnInit(): void {
    this.getdata();
    this.initiate();
    this.checkEdit();
    this.joinrequestForm.get("jointypeId").disable();
    this.joinrequestForm.get("cityId").disable();
  }
  getdata(){
    this._CityService.GetCity().subscribe((res) => {
      this.cities = res.data;
    });
    this._JoinTypeService.GetJoinType().subscribe((res) => {
      this.jointype = res.data;
    })
  }
  initiate(){
    this.joinrequestForm = this._FormBuilder.group({
      name: ['', Validators.required],
     address:['', Validators.required],
     mobile:['', [Validators.required, Validators.pattern(`^01[0125]{1}[0-9]{8}`)]],
     comments:['', Validators.required],
     jointypeId:['', Validators.required],
     cityId:['', Validators.required]
    });
  
  }
  checkEdit() {
    this._JoinRequestService.Data.subscribe((res) => {
      if (res != null) {
        console.log(res)
        this.name=res.name
        this.address=res.address
        this.mobile=res.mobile
        this.comments=res.comments
        this.joinType=res.joinTypeTitle
        this.city=res.cityTitle
        this.joinrequestForm = this._FormBuilder.group({
          name: [res.name, Validators.required],
          address:[res.address, Validators.required],
          mobile:[res.mobile, [Validators.required, Validators.pattern(`^01[0125]{1}[0-9]{8}`)]],
          comments:[res.comments, Validators.required],
          jointypeId:[res.joinTypeId, Validators.required],
          cityId:[res.cityId, Validators.required]
        });
        this.update = true;
        this.recordtoupdate = res ;
        console.log(this.recordtoupdate);
      } else {
        console.log(`not found on data`);
        // this.initiate();
      }
     
    });
  }
  onSubmit(){
    this.button = true;
  if(this.update == false && this.joinrequestForm.status == "VALID"){
    this._JoinRequestService.CreateJoinRequest(this.joinrequestForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التسجيل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.joinrequestForm.reset();
      this._Router.navigate(['/content/admin/ViewJoinRequest']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
  } else if(this.joinrequestForm.status == "VALID"){
    this.joinrequestForm.addControl('id', new FormControl(this.recordtoupdate.id, Validators.required));
    this._JoinRequestService.UpdateJoinRequest(this.joinrequestForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.joinrequestForm.reset();
      this._Router.navigate(['/content/admin/ViewJoinRequest']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
    }, () => {
      console.log('completed ');
    })
  }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ جميع الحقول"   
    })
    this.joinrequestForm.markAllAsTouched();
    this.button = false;
  }
  }
  ngOnDestroy(){
    this._JoinRequestService.Data.next(null);
    }

  get fc() {
    return this.joinrequestForm.controls;
  }
}
